import { usePrivacy } from "@/lib/privacy";

function maskName(value: string): string {
  const parts = value.trim().split(/\s+/);
  return parts.map((p) => p[0]?.toUpperCase() ?? "").join(".") + ".";
}

function maskEmail(value: string): string {
  if (!value.includes("@")) return maskName(value);
  const first = value[0] ?? "";
  return first.toLowerCase() + "***";
}

function maskNin(value: string): string {
  if (value.length <= 5) return "***********";
  return value.slice(0, 6) + "*****";
}

export function MaskedText({ value, type = "name" }: { value: string; type?: "name" | "email" | "nin" }) {
  const { revealed } = usePrivacy();

  if (!value) return <>{value}</>;
  if (revealed) return <>{value}</>;

  const masked = type === "email" ? maskEmail(value) : type === "nin" ? maskNin(value) : maskName(value);
  return <>{masked}</>;
}
